// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2abY5","approved":"Status_approved__1k8GG","rejected":"Status_rejected__1Pa1V","expired":"Status_expired__1rjep","label":"Status_label__KNpc0"};